import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import TransfersList from "features/transfers/TransfersList";
import TransferNew from "components/transfer-management/TransferNew";
import TransferNewExcel from "components/transfer-management/TransferNewBulk";
import TransferRegions from "components/transfer-management/TransferRegions";
import TransferReport from "features/transfers/TransferReport";
import Tabs from "components/ui/tabs/Tabs";

const TransfersPage = () => {
  const { t } = useTranslation();

  const transfersTabs = useMemo(
    () => [
      {
        label: t("transfersPage.transferTracking"),
        content: <TransferReport />,
      },
      {
        label: t("transfersPage.activeTransfers"),
        content: <TransfersList active={true} />,
      },
      {
        label: t("transfersPage.allTransfers"),
        content: <TransfersList active={false} />,
      },
      {
        label: t("transfersPage.uploadTransferFile"),
        content: <TransferNewExcel />,
      },
      {
        label: t("transfersPage.newTransfer"),
        content: <TransferNew />,
      },

      {
        label: t("transfersPage.regions"),
        content: <TransferRegions />,
      },
    ],
    [t]
  );

  return <Tabs tabs={transfersTabs} id="transfers-page" isVertical={true} />;
};

export default TransfersPage;
